import helpers from '~/helpers/product';
import { Link } from '#/renderer/Link';
import ESimIndicator from '~/components/ESimIndicator/ESimIndicator';
import PagoUnico from '~/components/productBox/PagoUnico';
import DetallePlanFijo from '~/containers/Home/DetallePlanFijo';
import { cuotaFormat, currencyFormat, imgFormat } from '~/helpers/formatter';
import { ATTR_TIPO_POSPAGO, CDN, CURRENCY, CURRENCY_SYMBOL, ESPOTS, LOCALE, POSPAGO } from '~/store/States/global';
import { PAGOUNICO, pricingPospago } from '~/store/States/pospago';

export default function ProductoDestacado({ prod, category, planes, config, pagoUnico }) {
  helpers.ordenar(prod);
  let attrMap;
  const item = prod.items.find((it) => {
    attrMap = helpers.convertAttributes(it.attributes);
    return attrMap['attr-conf-destacado'] === 'SI';
  });
  if (!item) {
    return null;
  }
  const tipoProducto = attrMap['attr-conf-tipoproducto'];
  const cuotas = attrMap['attr-conf-pagocuotas'];
  let textoCuota = attrMap['attr-texto-cuotas'];
  const endpoint =
    tipoProducto === 'OTRO'
      ? '/productx/'
      : tipoProducto === 'POSPAGO'
      ? '/productp/'
      : '/product/';
  const fullname = item.locales[LOCALE].name
    .replace(/<br>|<br\/>|\\n/g, '\n')
    .split('\n')
    .map((str, index) => <h3 key={index}>{str}</h3>);
  let img = 'Producto sin imagen';
  if (item && item.images && item.images.length) {
    img = (
      <img
        src={imgFormat(
          '210x180',
          `${CDN}${item.images[0]}`,
        )}
        alt="products"
        loading='lazy'
      />
    );
  }

  let label;
  let labelContado = '';
  let labelCuota = '';
  let labelPlan;
  let price;
  let priceclass = '';
  let sufix;
  let detail;
  let lblButton = 'Comprar';
  let incluido = false;
  let link = `${endpoint}${
    item.locales[LOCALE].seo.name
  }/${prod.part_number}`;
  let aceptaCuotas = false;
  let formatoCuotas = '';
  let precioMinimoCuotas = 0;
  let contado = 'Precio de contado';
  let mostrarCuotas = true;
  let isPagoUnico = false;

  switch (tipoProducto) {
    case 'PLAN': {
      label = 'Precio del plan';
      price = attrMap['attr-conf-precio-mensual'];
      sufix = <span>&nbsp;al mes</span>;
      lblButton = 'Contratar servicio';
      const redes = item.attributes
        .filter(
          (attr) =>
            /attr-redsocial/.test(attr.identifier) &&
            attr.value.toUpperCase() === 'SI',
        )
        .map((attr, idx) => (
          <img
            className="red-social"
            key={idx}
            src={`${CDN}/espots/socialmedia/${attr.identifier.replace(/-/g, '_')}.jpg`}
            alt={attr.identifier}
            loading='lazy'
          />
        ));
      detail = redes.length > 0 && (
        <>
          <div className="d-flex align-items-sm-center gap-2 flex-column flex-sm-row">
            <div className="fw-bold">Redes ilimitadas</div>
            <div className="d-flex gap-1 justify-content-between">{redes}</div>
          </div>
          <div>
            <Link to={link}>Ver más detalle</Link>
          </div>
        </>
      );
      break;
    }
    case 'PLANFIJO': {
      label = 'Precio del plan';
      price = item.pricing[CURRENCY].offer_price / 100;
      sufix = <span>&nbsp;al mes</span>;
      lblButton = 'Contratar servicio';
      const code =
        attrMap['attr-conf-friendly-url'] ||
        item.locales[LOCALE].seo.name ||
        item.part_number;
      const search = new URLSearchParams();
      search.set('plan', code);
      link = `/categories/${category.referrer}?${search.toString()}`;
      const internet = attrMap['attr-chars-titulo-internet'];
      const tv = attrMap['attr-chars-titulo-tv'];
      const llamadas = attrMap['attr-chars-titulo-llamadas'];
      const mensajes = attrMap['attr-chars-titulo-mensajes'];
      detail = (
        <div className="d-flex gap-2 flex-column destacado--detail">
          <div className="fw-bold">{(internet || tv || llamadas || mensajes) && 'Beneficios'}</div>
          <div className="d-flex gap-1 justify-content-between">
            {internet && (
              <div>
                <img
                  className=""
                  src={`${ESPOTS}/media/attr_detalle_internet_renovacion.png`}
                  alt="detalle internet"
                  loading="lazy"
                />
                <span>{internet}</span>
              </div>
            )}
            {tv && (
              <div>
                <img
                  className=""
                  src={`${ESPOTS}/media/attr_detalle_tv_renovacion.png`}
                  alt="detalle tv"
                  loading="lazy"
                />
                <span>{tv}</span>
              </div>
            )}
            {llamadas && (
              <div>
                <img
                  className=""
                  src={`${ESPOTS}/media/attr_detalle_llamadas_renovacion.png`}
                  alt="detalle llamadas"
                  loading="lazy"
                />
                <span>{llamadas}</span>
              </div>
            )}
            {mensajes && (
              <div>
                <img
                  className=""
                  src={`${ESPOTS}/media/attr_detalle_sms_renovacion.png`}
                  alt="detalle sms"
                  loading="lazy"
                />
                <span>{mensajes}</span>
              </div>
            )}
          </div>
          <div>
            <DetallePlanFijo item={item} />
          </div>
        </div>
      );
      break;
    }
    case 'POSPAGO': {
      label = 'Precio del equipo';
      if (config.textoPospago?.terminal) {
        label = config.textoPospago.terminal.textoPrecio ?? label;
        contado = config.textoPospago.terminal.textoContado ?? contado;
        mostrarCuotas = config.textoPospago.terminal.mostrarCuotas ?? mostrarCuotas;
      }
      const attrDefaultPlan = attrMap['attr-conf-default-plan']?.replace(/\./g, '_') || '';
      const plazo = attrMap['attr-conf-default-plazo'];
      const pricesT = pricingPospago(attrDefaultPlan, plazo, item.pricing, 'tarjeta', planes);
      const pricesP = pricingPospago(attrDefaultPlan, plazo, item.pricing, 'pospago', planes);
      let prices;
      if (pricesT && planes[pricesT.plan][ATTR_TIPO_POSPAGO] === PAGOUNICO) {
        prices = pricesT;
        isPagoUnico = true;
        label = pagoUnico.textos.precio;
        link = `${link}?tipo=${PAGOUNICO}`;
      } else {
        prices = pricesP;
      }

      if (prices) {
        let first = plazo;
        if (!first || !prices[first]) {
          first = Object.keys(prices).sort((a, b) => b - a)[0];
        }
        if (isPagoUnico) {
          textoCuota = first;
        }
        price = prices[first].offer_price;
        const namePlan = planes?.[prices.plan]?.name;
        labelPlan = namePlan && (
          <span className="product--plan-label">
            {isPagoUnico ? `${pagoUnico.textos.plan} ` : 'En un plan de '}
            <span className="product--plan-description">{namePlan}</span>
          </span>
        );
      } else {
        price = item.pricing[CURRENCY].offer_price / 100;
      }
      incluido = +config.precio_minimo_incluido >= price;
      precioMinimoCuotas = config.precioMinimoCuotas || 0;
      aceptaCuotas = price >= precioMinimoCuotas;
      formatoCuotas = (isPagoUnico ? pagoUnico : config).formatoCuotas || '';
      break;
    }
    default:
      label = 'Precio del equipo';
      price = item.pricing[CURRENCY].offer_price / 100;
      precioMinimoCuotas = config.precioMinimoCuotas || 0;
      aceptaCuotas = price >= precioMinimoCuotas;
      formatoCuotas = config.formatoCuotas || '';
  }
  if (cuotas === 'SI' && textoCuota && aceptaCuotas && mostrarCuotas) {
    if (!isPagoUnico) {
      label = attrMap['attr-titulo-cuotas'] || `${label} financiado`;
    }
    const precioCuota = +textoCuota;
    if (Number.isNaN(precioCuota)) {
      labelCuota = (
        <p
          className="price-cuota"
          dangerouslySetInnerHTML={{ __html: textoCuota }}
        />
      );
    } else {
      const cuota = currencyFormat(price / precioCuota, 1).split('.');
      labelCuota = cuotaFormat(cuota, textoCuota, formatoCuotas);
    }
    if (!isPagoUnico) {
      labelContado = <p className="price-before mb-0">{contado}</p>;
    }
    priceclass = 'cuota';
  }
  price = currencyFormat(price, 1).split('.');

  return (
    <div className="boxCard" style={{ position: 'relative' }}>
      <div className="boxCard--title">{fullname}</div>
      <div className="boxCard--img">
        <picture>{img}</picture>
      </div>
      {prod.hasVarianWithEsim && (
        <ESimIndicator
          label={prod.esimIndicator?.label}
          image={prod.esimIndicator?.image}
          top="var(--esim-top, 116px)"
        />
      )}
      {isPagoUnico && <PagoUnico />}
      <div className={`boxCard--price ${priceclass}`}>
        <div className="lbl">{label}</div>
        {incluido && tipoProducto === POSPAGO ? '' : labelCuota}
        {labelContado}
        <p className="price">
          {incluido ? (
            <span>INCLUIDO</span>
          ) : (
            !isPagoUnico && (
              <>
                <span className="currency">{CURRENCY_SYMBOL}</span>
                <span>{price[0]}.</span>
                <span className="decimal">{price[1]}</span>
                {sufix}
              </>
            )
          )}
        </p>
        {labelPlan}
      </div>
      <div className="boxCard--icons">{detail}</div>
      <div className="boxCard--button">
        <Link className="link" to={link}>
          {lblButton}
        </Link>
      </div>
    </div>
  );
}
